/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Some_Needs_BothInputs */

const en_us2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark at least one fixed day and one with no set day.`)
};

const pt_br2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um dia fixo e um sem dia marcado.`)
};

const es_419_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un día fijo y uno sin día fijo.`)
};

const pt_pt2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um dia fixo e um sem dia marcado.`)
};

const fr_fr2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coche au moins un jour fixe et un jour sans jour fixé.`)
};

const de_de2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere mindestens einen festen Tag und einen ohne festen Wochentag.`)
};

const it_it2_profile_editors_some_needs_both = /** @type {(inputs: Profile_Editors_Some_Needs_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna almeno un giorno fisso e uno senza giorno fisso.`)
};

/**
* | output |
* | --- |
* | "Mark at least one fixed day and one with no set day." |
*
* @param {Profile_Editors_Some_Needs_BothInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_some_needs_both = /** @type {((inputs?: Profile_Editors_Some_Needs_BothInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Some_Needs_BothInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_some_needs_both(inputs)
	if (locale === "es-419") return es_419_profile_editors_some_needs_both(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_some_needs_both(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_some_needs_both(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_some_needs_both(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_some_needs_both(inputs)
	return en_us2_profile_editors_some_needs_both(inputs)
});
export { profile_editors_some_needs_both as "profile-editors.some_needs_both" }